export default "__VITE_ASSET__DA2tujI0__"